/** Lingua base: inglese. Ogni altra lingua ricalca queste chiavi. */
export default {
  common: {
    loading: 'Loading…',
    loadingProject: 'Loading project…',
    cancel: 'Cancel',
    optional: '(optional)',
    you: 'you',
    dash: '—',
    serverError: 'Error {{status}}',
  },
  lang: {
    label: 'Language',
  },
  nav: {
    projects: 'Projects',
    tecnico: 'Technical office',
    admin: 'Administration',
    logout: 'Log out',
  },
  roles: {
    USER: 'User',
    TECNICO: 'Technician',
    ADMIN: 'Admin',
    badgeAdmin: 'admin',
    badgeTecnico: 'technician',
  },
  craneType: {
    CINGOLATA: 'Crawler crane',
    RAGNO: 'Spider crane',
    AUTOCARRATA: 'Truck-mounted crane',
    TORRE: 'Tower crane',
  },
  login: {
    titleLogin: 'Sign in to the configurator',
    titleRegister: 'Create an account',
    subtitle: 'BGLift 3D crane configurator',
    name: 'Name',
    email: 'Email',
    password: 'Password',
    submitLogin: 'Sign in',
    submitRegister: 'Sign up',
    toggleToRegister: "Don't have an account? Sign up",
    toggleToLogin: 'Already have an account? Sign in',
  },
  dashboard: {
    title: 'Your projects',
    subtitle: 'Saved lifting configurations',
    newProject: '+ New project',
    empty: 'No projects yet: create one to start configuring the crane.',
    createFirst: 'Create the first project',
    byUser: 'by {{name}}',
    updated: 'Updated {{date}}',
    certificatePdf: 'PDF certificate',
    resend: 'Resend for approval',
    sendForReview: 'Send for technical approval',
    openConfigurator: 'Open configurator',
    deleteTitle: 'Delete project',
    confirmDelete: 'Delete the project “{{name}}”?',
    modalTitle: 'New project',
    modalSubtitle: "Choose crane type and model: you'll configure it in the 3D scene.",
    projectName: 'Project name',
    projectNamePlaceholder: 'e.g. Via Roma site',
    craneType: 'Crane type',
    selectType: 'Select the type…',
    model: 'Model',
    selectModel: 'Select the model…',
    createProject: 'Create project',
    creating: 'Creating…',
  },
  configurator: {
    backToProjects: 'Back to projects',
    back: 'Projects',
    savedAt: 'Saved {{time}}',
    save: 'Save',
    saving: 'Saving…',
  },
  tecnico: {
    title: 'Technical office',
    subtitle: 'Configuration approval requests from customers',
    empty: 'No requests in the queue. New customer requests will appear here.',
    requestedBy: 'Request from {{name}} ({{email}}) · sent {{date}}',
    assignedTo: 'Assigned to {{name}}',
    openConfiguration: 'Open configuration',
    claim: 'Claim',
    certify: 'Attach PDF and certify',
    certifying: 'Uploading…',
  },
  admin: {
    title: 'Administration',
    subtitle: 'Manage users and crane model catalog',
    tabUsers: 'Users',
    tabModels: 'Crane models',
  },
  users: {
    newUser: '+ New user',
    colUser: 'User',
    colRole: 'Role',
    colStatus: 'Status',
    colProjects: 'Projects',
    colActions: 'Actions',
    active: 'Active',
    inactive: 'Disabled',
    resetPassword: 'Reset password',
    deactivate: 'Disable',
    reactivate: 'Reactivate',
    delete: 'Delete',
    modalTitle: 'New user',
    name: 'Name',
    email: 'Email',
    password: 'Password',
    role: 'Role',
    createUser: 'Create user',
    creating: 'Creating…',
    promptResetPassword: 'New password for {{email}} (min 6 characters):',
    passwordUpdated: 'Password updated.',
    confirmDelete: 'Permanently delete {{email}}? Their {{count}} projects will also be deleted.',
  },
  models: {
    newModel: '+ New model',
    colCode: 'Code',
    colName: 'Name',
    colType: 'Type',
    colFile3d: '3D file',
    colProjects: 'Projects',
    colStatus: 'Status',
    colActions: 'Actions',
    active: 'Active',
    inactive: 'Disabled',
    deactivate: 'Disable',
    activate: 'Enable',
    delete: 'Delete',
    confirmDelete: 'Delete model {{code}}?',
    modalTitle: 'New crane model',
    modalSubtitle:
      'You need the 3D file (.glb) and the JSON file with technical data (geometry, load chart, default configuration — same structure as BR0089.json).',
    code: 'Code',
    codePlaceholder: 'e.g. BR0100',
    craneType: 'Crane type',
    name: 'Name',
    namePlaceholder: 'e.g. BGLift BR0100',
    description: 'Description',
    file3d: '3D file (.glb)',
    dataFile: 'Technical data (.json)',
    createModel: 'Create model',
    creating: 'Uploading…',
  },
  controls: {
    realtimeCalc: 'Real-time capacity calculation',
    reset: 'Reset',
    resetField: 'Reset',
    restore: 'Restore',
    legFrontLeft: 'Front left',
    legFrontRight: 'Front right',
    legRearLeft: 'Rear left',
    legRearRight: 'Rear right',
    groupLoad: 'Load',
    loadWeight: 'Lifted weight',
    maxSwl: 'Max capacity (SWL)',
    loadUtil: 'Load usage',
    groupAerial: 'Aerial group',
    boom: 'Boom',
    angle: 'Angle',
    extensionStroke: 'Extension stroke',
    borePressure: 'Bore pressure',
    rodPressure: 'Rod pressure',
    turretRotation: 'Turret rotation',
    workRadius: 'Working radius',
    jib: 'Jib',
    jibAngle: 'Jib angle',
    groupGround: 'Ground group',
    opening: 'Opening',
    footHeight: 'Foot height',
    knee: 'Knee',
    groundHelp:
      'Opening and Knee have fixed positions (holes on the machine), adjustable leg by leg: opening 0° = folded along the carriage, {{deg}}° = fully open; knee 0° = shin in design position. Foot height: 0 = foot on the ground, positive values = foot on a higher support (still resting and load-bearing). Reactions use the real foot positions derived from opening, knee and foot height (geometry from the BGLift drawing); machine masses remain indicative.',
    disclaimer:
      'Prototype with indicative SWL data. Always validate against the official BGLift chart and the EN 13000 standard before use on site.',
  },
  status: {
    safe: 'SAFE',
    warning: 'WARNING',
    critical: 'CRITICAL — STOP',
    shortSafe: 'OK',
    shortWarning: 'WARN',
    shortCritical: 'STOP',
    calculating: 'Calculating…',
    radius: 'Radius',
    swl: 'SWL',
    loadUtil: 'Load usage',
    padUtil: 'Max pad usage',
    tippingMargin: 'Tipping margin',
    en13000: 'EN 13000 — tipping at 0% · warning threshold at 20%',
    controls: 'Controls',
  },
  review: {
    requested: 'Sent to technical office',
    inReview: 'Assigned to technical office',
    certified: 'Configuration certified',
    certificatePdf: 'PDF certificate',
    sending: 'Sending…',
    resend: 'Resend for approval',
    send: 'Send for technical approval',
  },
  crane3d: {
    loading: 'Loading…',
  },
}
